"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefixHttp = prefixHttp;
exports.prefixEnv = void 0;

var prefixEnv = function prefixEnv(env) {
  return function (edition) {
    if (edition.isLegacy && env !== 'live') {
      return Object.assign({}, edition, {
        link: "".concat(env, ".").concat(edition.link)
      });
    } else {
      return edition;
    }
  };
};

exports.prefixEnv = prefixEnv;

function prefixHttp(edition) {
  if (edition.isLegacy) {
    return Object.assign({}, edition, {
      link: "http://".concat(edition.link)
    });
  } else {
    return edition;
  }
}